import theme from '@styles/theme';
export default {
  container: {
    width: '100%',
    display: 'flex',
    alignItens: 'flex-start',
    flexDirection: ['column', 'column', 'row'],
    gap: ['24px', '24px', '9.375vh'],
    paddingRight: '8.28125vh',
    paddingTop: [0, 0, '9px', '9px', '17px'],
    paddingBottom: ['20px', '20px', '30px', '30px', '38px']
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '24px',
    flex: '1 0 0'
  },
  singleProperty: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  imageContainer: {
    position: 'relative',
    width: '60px',
    height: '60px',
    flexShrink: 0
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center'
  },
  textContainer: {
    color: theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '140%'
  },
  properties: {
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.text,
    lineHeight: '175%',
    color: theme.rawColors.darkGrey700,
    'ul > li': {
      '&:before': {
        display: 'flex',
        alignItems: 'center'
      }
    },
    'li::marker': {
      display: 'block',
      pr: '4px'
    },
    'ul>li:before': {
      width: '4px',
      height: '4px',
      background: theme.rawColors.darkGrey700,
      top: '12px'
    }
  }
};